module.exports = __webpack_public_path__ + "static/media/introduction-recibase_05.6f6bbfc2.jpg";